import { apiPost } from 'ApiPackage/MainModule/common/apiTools';
import { config } from 'CorePackage/MainModule/constants/config';

export async function fetchUploadFile(data: FormData): Promise<number> {
  return apiPost({ url: `${config.server}/feedback/attach`, body: data });
}
